import { createContext } from 'preact';

export const RouterContext = createContext<RouterParentState>({ pathPrefix: '/' });

export interface RouterParentState {
    pathPrefix: string;
}
